module.exports = __webpack_public_path__ + "assets/img/图片一.a5174016.png";